import React, { createContext, useContext, useRef, useCallback } from "react";

const GlobalLoadingContext = createContext();

export function GlobalLoadingProvider({ children }) {
  const loadingRef = useRef(null);
  
  const showLoading = useCallback(() => {
    loadingRef.current?.show();
  }, []);
  
  const hideLoading = useCallback(() => {
    loadingRef.current?.hide();
  }, []);
  
  const showFailed = useCallback(() => {
    loadingRef.current?.showFailed();
  }, []);
  
  return (
    <GlobalLoadingContext.Provider value={{ showLoading, hideLoading, showFailed, loadingRef }}>
      {children}
    </GlobalLoadingContext.Provider>
  );
}

export function useGlobalLoading() {
  const context = useContext(GlobalLoadingContext);
  if (!context) {
    throw new Error("useGlobalLoading must be used within a GlobalLoadingProvider");
  }
  return context;
}

